import React from 'react';
import type { LayoutChangeEvent, ViewStyle } from 'react-native';

import {
  width as widthStyleUtil,
  height as heightStyleUtil,
} from '../style-utils';

type UseAspectRatioProps = {
  width: string | number;
  ratio: string | number;
};

export const useAspectRatio = ({ width, ratio }: UseAspectRatioProps) => {
  const [sizeStyle, setSizeStyle] = React.useState<ViewStyle[]>([
    widthStyleUtil(width),
    heightStyleUtil(0),
  ]);

  const onAspectRatioLayout = React.useCallback(
    (event: LayoutChangeEvent) => {
      const updateSizeStyle = (height: number) =>
        setSizeStyle((sizeStyle) => [...sizeStyle, heightStyleUtil(height)]);

      const layoutWidth = event?.nativeEvent.layout.width;

      switch (typeof ratio) {
        case 'number':
          updateSizeStyle(Math.floor(layoutWidth / ratio));
          break;

        case 'string':
          // eslint-disable-next-line no-case-declarations
          const [w, h] = ratio.split(':');
          updateSizeStyle(Math.floor(layoutWidth / (Number(w) / Number(h))));
          break;
      }
    },
    [ratio]
  );

  return {
    sizeStyle,
    onAspectRatioLayout,
  };
};
